{
  "AGENT_BOTS": {
    "HEADER": "Botok",
    "LOADING_EDITOR": "Szerkesztő betöltése...",
    "DESCRIPTION": "Agent Bots are like the most fabulous members of your team. They can handle the small stuff, so you can focus on the stuff that matters. Give them a try.You can manage your bots from this page or create new ones using the 'Configure new bot' button.",
    "LEARN_MORE": "Tudjon meg többet az ügynök botokról",
    "GLOBAL_BOT": "Rendszerbot",
    "GLOBAL_BOT_BADGE": "Rendszer",
    "AVATAR": {
      "SUCCESS_DELETE": "A bot avatár sikeresen törölve",
      "ERROR_DELETE": "Hiba a bot avatár törlésekor, kérjük, próbálja újra"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Válassz ügynököt",
      "DESC": "Rendeljen egy Agent Botot a postaládájához. Ők képesek kezelni a kezdeti beszélgetéseket, és szükség esetén átirányítani őket egy emberhez.",
      "OPTION": "{name} ({description})",
      "SUBMIT": "Frissítés",
      "DISCONNECT": "Bot lekapcsolása",
      "SUCCESS_MESSAGE": "Ügynök frissítve.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Ügynök leválasztva.",
      "ERROR_MESSAGE": "Nem sikerült frissíteni a botot. Kérjük, próbálja meg újra.",
      "DISCONNECTED_ERROR_MESSAGE": "Nem sikerült leválasztani az botot. Kérjük, próbálja meg újra.",
      "SELECT_PLACEHOLDER": "Válassza ki a botot",
      "COUNTRY_BOTS": {
        "TITLE": "Botok országok szerint",
        "DESC": "Ez a postaláda több országot szolgál ki. A beszélgetés az országának botjához kerül: a Kaufland áruház, az Allegro-rendelés piactere, ennek hiányában a vásárló által használt nyelv alapján. Minden más beszélgetés a fenti alapértelmezett botot kapja.",
        "COUNTRY": "Válasszon országot",
        "BOT": "Válassza ki a botot",
        "ADD": "Országspecifikus bot hozzáadása",
        "REMOVE": "Eltávolítás",
        "DEFAULT_REQUIRED": "Előbb válasszon alapértelmezett botot. Egy ország botja csak az adott országra váltja le.",
        "DISCONNECT_ALL": "Összes bot lekapcsolása"
      }
    },
    "ADD": {
      "TITLE": "Új bot beállítása",
      "CANCEL_BUTTON_TEXT": "Mégse",
      "API": {
        "SUCCESS_MESSAGE": "Bot hozzáadva.",
        "ERROR_MESSAGE": "Nem tudott botot hozzáadni. Kérjük, próbálja meg később újra."
      }
    },
    "LIST": {
      "404": "Nem találtunk botokat. A 'Új bot konfigurálása' gombra kattintva hozhat létre botot ↗",
      "LOADING": "Botok hívása...",
      "TABLE_HEADER": {
        "DETAILS": "Bot adatai",
        "URL": "Webhook URL"
      },
      "TYPE": "Bot típus"
    },
    "DELETE": {
      "BUTTON_TEXT": "Törlés",
      "TITLE": "Bot törlése",
      "CONFIRM": {
        "TITLE": "Törlés megerősítése",
        "MESSAGE": "Biztosan törölni szeretné a következőt: {name}?",
        "YES": "Igen, törlés",
        "NO": "Nem, megtartás"
      },
      "API": {
        "SUCCESS_MESSAGE": "Bot törölve.",
        "ERROR_MESSAGE": "Nem sikerült törölni a botot. Kérjük, próbálja újra."
      },
      "SUBMIT": "Törlés",
      "CANCEL_BUTTON_TEXT": "Mégse",
      "DESCRIPTION": "Biztosan törölni szeretnéd ezt a botot? Ez a művelet visszafordíthatatlan."
    },
    "EDIT": {
      "BUTTON_TEXT": "Szerkesztés",
      "TITLE": "Bot szerkesztése",
      "API": {
        "SUCCESS_MESSAGE": "Bot frissítve.",
        "ERROR_MESSAGE": "Nem tudta frissíteni a botot. Kérjük, próbálja újra."
      },
      "LOADING": "Botok hívása...",
      "CANCEL_BUTTON_TEXT": "Mégse"
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Bot avatár"
      },
      "NAME": {
        "LABEL": "Bot neve",
        "PLACEHOLDER": "Adja meg a bot nevét",
        "REQUIRED": "A bot neve kötelező"
      },
      "DESCRIPTION": {
        "LABEL": "Leírás",
        "PLACEHOLDER": "Mit csinál ez a bot?"
      },
      "WEBHOOK_URL": {
        "LABEL": "Webhook URL",
        "PLACEHOLDER": "https://example.com/webhook",
        "REQUIRED": "A Webhook URL megadása kötelező"
      },
      "ERRORS": {
        "NAME": "A bot neve kötelező",
        "URL": "A Webhook URL megadása kötelező",
        "VALID_URL": "Adjon meg egy érvényes URL-t, amely http:// vagy https:// előtaggal kezdődik"
      },
      "CANCEL": "Mégse",
      "CREATE": "Bot létrehozása",
      "UPDATE": "Bot frissítése"
    },
    "WEBHOOK": {
      "DESCRIPTION": "Állítson be egy webhook botot, amely integrálódik az egyéni szolgáltatásaival. A bot megkapja és feldolgozza a beszélgetésekből származó eseményeket, és válaszolhat rájuk."
    },
    "TYPES": {
      "WEBHOOK": "Webhook bot",
      "CSML": "CSML bot"
    },
    "CSML_BOT_EDITOR": {
      "NAME": {
        "LABEL": "Bot neve",
        "PLACEHOLDER": "Nevezd el a botodat.",
        "ERROR": "Bot név megadása kötelező."
      },
      "DESCRIPTION": {
        "LABEL": "Bot leírás",
        "PLACEHOLDER": "Mit csinál ez a bot?"
      },
      "BOT_CONFIG": {
        "ERROR": "Add meg a CSML bot konfigurációt feljebb.",
        "API_ERROR": "A CSML konfigurációja érvénytelen. Kérjük, javítsa ki és próbálja meg újra."
      },
      "SUBMIT": "Validáció és mentés"
    }
  }
}
